define(function () {
    function Model(jsonModel) {
        this.value = ko.observable(jsonModel.value).unwrap().default('#fff');
        this.onPick = jsonModel.onPick || _.noop;
        this.onHide = jsonModel.onHide || _.noop;
    }

    return Model;
});